import Vue from 'vue'
import axios from 'axios'
import { events } from '@main/js/bus'

const defaultState = {
  processingPopup: undefined,
  fileQueue: [],
  filesInQueueTotal: 0,
  filesInQueueUploaded: 0,

  isProcessingFile: false,
  isProcessingFolder: false,
  uploadingProgress: 0,
}

const actions = {
  async proceedFolder({ commit, state, getters, rootGetters }, data) {
    let apiUrl = rootGetters.api

    // Prefer the latest backend-issued token from cookie; fall back to Vuex/localStorage
    const cookieToken =
      typeof document !== 'undefined' && document.cookie
        ? decodeURIComponent(
            (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
          )
        : ''
    const storedToken = rootGetters.token || localStorage.getItem('token') || ''
    const token = cookieToken || storedToken

    // Debug token resolution for create-folder 401 issues (dev only)
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log('[fileFunctions.proceedFolder] token debug', {
        hasRootGetterToken: !!rootGetters.token,
        hasLocalStorageToken: !!localStorage.getItem('token'),
        cookieSnippet:
          typeof document !== 'undefined' && document.cookie
            ? document.cookie.replace(/token=([^;]*)/, 'token=***')
            : null,
        source: cookieToken
          ? 'cookie'
          : storedToken
            ? 'store/localStorage'
            : 'none',
        cookieTokenPrefix: cookieToken
          ? cookieToken.substring(0, 10) + '...'
          : null,
        storedTokenPrefix: storedToken
          ? storedToken.substring(0, 10) + '...'
          : null,
        resolvedTokenPrefix: token ? token.substring(0, 10) + '...' : null,
      })
    }

    const configHeaders = {
      'content-type': 'application/json',
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': '*',
      ...(token ? { Authorization: 'Bearer ' + token } : {}),
    }

    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: 'create-folder',
        baseURL: apiUrl,
        headers: configHeaders,
        data: data,
      })
        .then((response) => {
          // request succeeded
          resolve(response) // return response data to calling function
        })
        .catch((error) => {
          // Show login prompt only on 401
          if (error?.response?.status === 401) {
            events.$emit('alert:open', {
              emoji: '🔒',
              title: 'Reikalingas autentifikavimas',
              message: 'Norėdami tęsti, prisijunkite.',
            })
          }
          reject(error)
        })
    })
  },
  uploadFiles: (
    { commit, getters, rootGetters },
    { form, fileSize, totalUploadedSize },
  ) => {
    return new Promise((resolve, reject) => {
      // Mark as processing immediately so UI shows overlay
      commit('PROCESSING_FILE', true)
      // Get route
      /*      let route =
        getters.sharedDetail && !getters.sharedDetail.protected
          ? '/api/upload/public/' + router.currentRoute.params.token
          : '/api/upload'*/

      //let apiUrl = 'http://ep-client.go/endpoint/'
      let apiUrl = rootGetters.api

      const cookieToken =
        typeof document !== 'undefined' && document.cookie
          ? decodeURIComponent(
              (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
            )
          : ''
      const storedToken =
        rootGetters.token || localStorage.getItem('token') || ''
      const token = cookieToken || storedToken
      const configHeaders = {
        'Content-Type': 'application/octet-stream',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...(token ? { Authorization: 'Bearer ' + token } : {}),
      }

      let route = apiUrl + '/upload'

      // Create cancel token for axios cancellation
      const CancelToken = axios.CancelToken,
        source = CancelToken.source()

      axios
        .post(route, form, {
          cancelToken: source.token,
          headers: configHeaders,
          onUploadProgress: (event) => {
            let percentCompleted = Math.floor(
              ((totalUploadedSize + event.loaded) / fileSize) * 100,
            )

            commit(
              'UPLOADING_FILE_PROGRESS',
              percentCompleted >= 100 ? 100 : percentCompleted,
            )

            // Set processing file
            if (percentCompleted >= 100) commit('PROCESSING_FILE', true)
          },
        })
        .then((response) => {
          resolve(response)

          commit('PROCESSING_FILE', false)

          // Remove first file from file queue
          commit('SHIFT_FROM_FILE_QUEUE')

          // Check if user is in uploading folder, if yes, than show new file
          //if (response.data.folder_id == getters.currentFolder.unique_id) {
          // Add uploaded item into view
          commit('ADD_NEW_ITEMS', response.data)

          /*            commit('attribute/setFiles', {
              files: getters.data
            })*/

          // Reset file progress
          commit('UPLOADING_FILE_PROGRESS', 0)

          // Increase count in files in queue uploaded for 1
          commit('INCREASE_FILES_IN_QUEUE_UPLOADED')
          //}

          // Start uploading next file if file queue is not empty
          if (getters.fileQueue.length) {
            Vue.prototype.$handleUploading(getters.fileQueue[0])
          }

          // Reset upload process
          if (!getters.fileQueue.length) commit('CLEAR_UPLOAD_PROGRESS')
        })
        .catch((error) => {
          // Show login prompt only on 401
          if (error?.response?.status === 401) {
            events.$emit('alert:open', {
              emoji: '🔒',
              title: 'Reikalingas autentifikavimas',
              message: 'Norėdami tęsti, prisijunkite.',
            })
          }
          reject(error)

          let messages = {
            423: {
              title: Vue.prototype.trans('popup_exceed_limit.title'),
              message: Vue.prototype.trans('popup_exceed_limit.message'),
            },
            415: {
              title: Vue.prototype.trans('popup_mimetypes_blacklist.title'),
              message: Vue.prototype.trans('popup_mimetypes_blacklist.message'),
            },
            413: {
              title: Vue.prototype.trans('popup_paylod_error.title'),
              message: Vue.prototype.trans('popup_paylod_error.message'),
            },
          }

          const statusCode = error.response?.status || 500
          const message = messages[statusCode] || {
            title: 'Klaida',
            message: 'Įkeliant failą įvyko klaida.',
          }

          events.$emit('alert:open', {
            emoji: '',
            title: message.title,
            message: message.message,
          })

          commit('PROCESSING_FILE', false)
          commit('CLEAR_UPLOAD_PROGRESS')
        })

      // Cancel the upload request
      events.$on('cancel-upload', () => {
        source.cancel()

        // Hide upload progress bar
        commit('PROCESSING_FILE', false)
        commit('CLEAR_UPLOAD_PROGRESS')
      })
    })
  },
  deleteItem: ({ commit, getters, rootGetters }, item) => {
    return new Promise((resolve, reject) => {
      let apiUrl = rootGetters.api
      // Prefer cookie token (latest from backend), then Vuex/localStorage
      const cookieToken =
        typeof document !== 'undefined' && document.cookie
          ? decodeURIComponent(
              (document.cookie.match(/(?:^|; )token=([^;]*)/) || [])[1] || '',
            )
          : ''
      let storedToken = rootGetters.token || localStorage.getItem('token') || ''
      let token = cookieToken || storedToken

      console.log('Delete item debug:', {
        apiUrl,
        token: token ? 'exists' : 'missing',
        tokenLength: token?.length,
        tokenPrefix: token ? token.substring(0, 10) + '...' : 'none',
        cookieTokenPrefix: cookieToken
          ? cookieToken.substring(0, 10) + '...'
          : 'none',
        storedTokenPrefix: storedToken
          ? storedToken.substring(0, 10) + '...'
          : 'none',
        tokenSource: cookieToken
          ? 'cookie'
          : storedToken
            ? 'store/localStorage'
            : 'none',
        item: item,
        rootGettersToken: rootGetters.token
          ? 'has rootGetters.token'
          : 'no rootGetters.token',
        localStorageToken: localStorage.getItem('token')
          ? 'has localStorage token'
          : 'no localStorage token',
      })

      // Use Bearer token authentication like uploadFiles (if token available)
      const configHeaders = {
        'content-type': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ...(token ? { Authorization: 'Bearer ' + token } : {}),
      }

      // Prepare delete payload
      const deletedItems = [
        {
          unique_id: String(item.unique_id), // Ensure it's a string
          type: item.type || 'file',
          force_delete: false,
        },
      ]

      let route = apiUrl + '/remove-item'

      axios
        .post(
          route,
          {
            data: deletedItems,
          },
          {
            headers: configHeaders,
            // Treat 204 No Content as success as well
            validateStatus: (status) =>
              (status >= 200 && status < 300) || status === 204,
          },
        )
        .then((response) => {
          // Remove item from store data even if backend returns 204 (no content)
          commit('REMOVE_ITEM', item.unique_id)

          // Emit event for other components
          events.$emit('file:deleted', item.unique_id)

          resolve(response)
        })
        .catch((error) => {
          // Gracefully treat 204 from Axios error (some proxies misreport it)
          if (error?.response?.status === 204) {
            commit('REMOVE_ITEM', item.unique_id)
            events.$emit('file:deleted', item.unique_id)
            return resolve()
          }

          if (error?.response?.status === 401) {
            events.$emit('alert:open', {
              emoji: '🔒',
              title: 'Reikalingas autentifikavimas',
              message: 'Norėdami tęsti, prisijunkite.',
            })
          } else {
            console.error('Delete error:', error)
            events.$emit('alert:open', {
              emoji: '❌',
              title: 'Ištrinti nepavyko',
              message: 'Nepavyko ištrinti failo.',
            })
          }
          reject(error)
        })
    })
  },
}

const mutations = {
  ADD_FILES_TO_QUEUE(state, file) {
    state.fileQueue.push(file)
  },
  INCREASE_FILES_IN_QUEUES_TOTAL(state, count) {
    state.filesInQueueTotal += count
  },
  PROCESSING_FOLDER(state, status) {
    state.isProcessingFolder = status
  },
  UPLOADING_FILE_PROGRESS(state, percentage) {
    state.uploadingProgress = percentage
  },
  PROCESSING_FILE(state, status) {
    state.isProcessingFile = status
  },
  SHIFT_FROM_FILE_QUEUE(state) {
    state.fileQueue.shift()
  },
  INCREASE_FILES_IN_QUEUE_UPLOADED(state) {
    state.filesInQueueUploaded++
  },
  CLEAR_UPLOAD_PROGRESS(state) {
    state.filesInQueueUploaded = 0
    state.filesInQueueTotal = 0
    state.fileQueue = []
    state.uploadingProgress = 0
  },
  SET_FILES_IN_QUEUE_TOTAL(state, total) {
    state.filesInQueueTotal = Number(total) || 0
  },
}

const getters = {
  filesInQueueUploaded: (state) => state.filesInQueueUploaded,
  filesInQueueTotal: (state) => state.filesInQueueTotal,
  uploadingProgress: (state) => state.uploadingProgress,
  isProcessingFile: (state) => state.isProcessingFile,
  isProcessingFolder: (state) => state.isProcessingFolder,
  processingPopup: (state) => state.processingPopup,
  fileQueue: (state) => state.fileQueue,
}

export default {
  state: defaultState,
  mutations,
  actions,
  getters,
}
